import { Modal, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { Spacing, SpacingUnit } from 'components/ui/Spacing';
import { DEFAULT_TEXT_CONFIG } from 'config/texts';

import { CommentComponentsCommonProps } from '../types';

import { DELETE_ACTIVITY_MODAL_TEXTS } from './texts';

const DeleteActivityModal: React.FC<CommentComponentsCommonProps> = ({
  commentsStore,
}) => {
  return (
    <Modal
      okText={DEFAULT_TEXT_CONFIG.SEND_BUTTON}
      cancelText={DEFAULT_TEXT_CONFIG.CANCEL_BUTTON}
      onOk={commentsStore.deleteActivity}
      onCancel={commentsStore.handleCancelDelete}
      title={DELETE_ACTIVITY_MODAL_TEXTS.DELETE_COMMENT}
      confirmLoading={commentsStore.fetchingDelete}
      centered
      open={commentsStore.deleteModal.opened}
    >
      <Spacing spacing={SpacingUnit.none}>
        <Typography.Text>
          {DELETE_ACTIVITY_MODAL_TEXTS.CONFIRMATION}
        </Typography.Text>
        <Typography.Text>
          {DELETE_ACTIVITY_MODAL_TEXTS.NON_CANCELABLE}
        </Typography.Text>
      </Spacing>
    </Modal>
  );
};

export default observer(DeleteActivityModal);
